import { render } from "./ChangePaymentAction.vue?vue&type=template&id=701157c7"
import script from "./ChangePaymentAction.vue?vue&type=script&lang=js"
export * from "./ChangePaymentAction.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__